import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import humanTime from 'flarum/common/helpers/humanTime';
import username from 'flarum/common/helpers/username';
import classList from 'flarum/common/utils/classList';
import StatusBadge from './StatusBadge';
const TABS = [{
  key: 'replies',
  sort: '-lastPostedAt'
}, {
  key: 'new',
  sort: '-createdAt'
}, {
  key: 'popular',
  sort: '-commentCount'
}];
const LIMIT = 12;
export default class ActivityFeed extends Component {
  active = (() => TABS[0].key)();
  loading = true;
  items = {};
  oninit(vnode) {
    super.oninit(vnode);
    this.load(this.active);
  }
  load(key) {
    const tab = TABS.find(t => t.key === key);
    this.active = key;
    if (this.items[key]) {
      this.loading = false;
      return;
    }
    this.loading = true;
    app.store.find('discussions', {
      sort: tab.sort,
      filter: tab.filter || {},
      page: {
        limit: LIMIT
      },
      include: 'user,lastPostedUser,nhStatus'
    }).then(list => {
      this.items[key] = list;
    }).catch(() => {
      this.items[key] = [];
    }).then(() => {
      this.loading = false;
      m.redraw();
    });
  }
  view() {
    const list = this.items[this.active] || [];
    return m("section", {
      className: "NhFeed"
    }, m("nav", {
      className: "NhFeed-tabs",
      role: "tablist"
    }, TABS.map(tab => m("button", {
      type: "button",
      role: "tab",
      className: classList('NhFeed-tab', this.active === tab.key && 'active'),
      "aria-selected": this.active === tab.key,
      onclick: () => this.load(tab.key)
    }, app.translator.trans(`neverhack-forum-nodes.forum.feed.tabs.${tab.key}`)))), m("div", {
      className: "NhFeed-body"
    }, this.loading ? m(LoadingIndicator, null) : list.length === 0 ? m("p", {
      className: "NhFeed-empty"
    }, app.translator.trans('neverhack-forum-nodes.forum.feed.empty')) : m("ol", {
      className: "NhFeed-list"
    }, list.map(d => this.row(d)))));
  }
  row(discussion) {
    const isNew = this.active === 'new';
    const user = isNew ? discussion.user() : discussion.lastPostedUser() || discussion.user();
    const time = isNew ? discussion.createdAt() : discussion.lastPostedAt() || discussion.createdAt();
    const jumpTo = isNew ? undefined : discussion.lastPostNumber() || undefined;
    const status = discussion.nhStatus?.() ?? null;
    return m("li", {
      className: "NhFeed-row",
      key: discussion.id()
    }, m(Link, {
      href: app.route.discussion(discussion, jumpTo),
      className: "NhFeed-link"
    }, m("span", {
      className: "NhFeed-chevron",
      "aria-hidden": "true"
    }, "\xBB"), m(StatusBadge, {
      status: status,
      className: "NhFeed-status"
    }), m("span", {
      className: "NhFeed-title"
    }, discussion.title())), m("span", {
      className: "NhFeed-time"
    }, humanTime(time)), m("span", {
      className: "NhFeed-user"
    }, user ? m(Link, {
      href: app.route.user(user),
      className: "NhFeed-userLink"
    }, username(user)) : username(null)));
  }
}
flarum.reg.add('neverhack-forum-nodes', 'forum/components/ActivityFeed', ActivityFeed);